export default __webpack_public_path__ + "static/media/texture2.5340eea4.png";